import uiRouter from '@uirouter/angularjs';
import angular from 'angular';

OrdersTransactionsDetailController.$inject = [
  '$scope',
  '$state',
  '$filter',
  '$timeout',
  'HelpersService',
  'CalendarService',
  'TransactionsData',
  'GridDefinitionFactory',
  'GridStateFactory',
  'UserPreferencesService',
];

function OrdersTransactionsDetailController(
  $scope,
  $state,
  $filter,
  $timeout,
  HelpersService,
  CalendarService,
  TransactionsData,
  GridDefinitionFactory,
  GridStateFactory,
  UserPreferencesService
) {
  $scope.ordersTransactionsDetail = {
    viewId: '',
    model: {},
    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),
    transactionDetailGridName: $state.current.name + '.grid0',
    dateFormat: UserPreferencesService.getDateFormat('standardDate', 'dateFormat'),
    hourFormat: UserPreferencesService.getDateFormat('standardTime', 'hourFormat'),
    parentDateFormat: UserPreferencesService.getDateFormat('sortDate', 'dateFormat'),
    dateTimeFormat: UserPreferencesService.getDateTimeFormat('sortDateTime'),

    optionsOverride: {
      useAccessibleGrid: true,
      data: 'ordersTransactionsDetail.model.transactionItems',
      useExternalPagination: false,
      useExternalSorting: false,
      columnDefs: [
        {
          field: 'id',
          displayName: 'Transaction Id',
          visible: false,
        },
        {
          field: 'eventName',
          displayName: 'Event',
          visible: true,
        },
        {
          field: 'unitPrice',
          displayName: 'Price',
          visible: true,
        },
        {
          field: 'discountedOrderAmount',
          displayName: 'Discounted Order Amt.',
          visible: true,
        },
        {
          field: 'amount',
          displayName: 'Amount',
          visible: true,
        },
        {
          field: 'netAmount',
          displayName: 'Net',
          visible: true,
        },
        {
          field: 'discountedTransactionAmount',
          displayName: 'Discounted Transaction Amt.',
          visible: true,
        },
        {
          field: 'itemType',
          displayName: 'Type',
          visible: true,
        },
        {
          field: 'ticketTypeName',
          displayName: 'Name',
          visible: true,
        },
        {
          field: 'quantity',
          displayName: 'Qty.',
          visible: true,
        },
        {
          field: 'purchaseType',
          displayName: 'Purch. Type',
          visible: true,
        },
        {
          field: 'saleType',
          displayName: 'Sale Type',
          visible: true,
        },
        {
          field: 'displayEventStartTime',
          displayName: 'Start Date',
          visible: true,
          sort: {
            direction: 'asc',
          },
        },
      ],
    },

    orderDetails: {
      columns: 2,
      data: 'ordersTransactionsDetail.model.transaction',
      include: [
        'orderNumber',
        'orderAmount',
        'discountedOrderAmount',
        'orderBalance',
        'balanceAmount',
        'paymentDueDisplayDate',
        'resellerServiceFee',
        'resellerServiceFeePercentage',
        'serviceFee',
        'serviceFeePercentage',
        'fixedFee',
        'percentFee',
        'transactionAmount',
        'netTransactionAmount',
        'discountedTransactionAmount',
        'transactionDisplayDate',
        'transactionType',
        'saleChannel',
        'terminalId',
        'paymentStatus',
        'incidentReasonCode',
        'legacy',
      ],
      mappings: {
        legacy: 'Order Type',
      },
    },

    billingDetails: {
      columns: 1,
      data: 'ordersTransactionsDetail.model.transaction',
      include: [
        'billingFirstName',
        'billingLastName',
        'billingEmail',
        'billingPhoneNumber',
        'billingAddress1',
        'billingAddress2',
        'billingCity',
        'billingState',
        'billingZipCode',
        'billingCountry',
      ],
    },

    contactDetails: {
      columns: 1,
      data: 'ordersTransactionsDetail.model.transaction',
      include: [
        'contactFirstName',
        'contactLastName',
        'email',
        'phoneNumber',
        'address1',
        'address2',
        'city',
        'state',
        'zipCode',
        'country',
      ],
    },

    init: function () {
      this.viewId = $state.current.name;

      $scope.$emit('Application::contentTitleChange', {
        title: 'Order Transaction Details',
        buttonLeft: {
          label: 'Back',
          permissions: ['ORDER_VIEW'],
          action: function () {
            window.history.go(-1);
          },
        },
      });

      $scope.$on('DataGrid::UserPreferencesLoaded', this.initData);

      this.gridDefinition.init(
        this.transactionDetailGridName,
        this.optionsOverride,
        this.viewId,
        $state.current.data.enablePreferences
      );
    },

    initData: function () {
      const self = $scope.ordersTransactionsDetail;
      if (TransactionsData && TransactionsData.data.success) {
        self.success.init(TransactionsData);
      } else {
        self.error.init(TransactionsData);
      }
    },

    cancel: function () {
      $state.go('application.orders.transactions', { orderId: $state.params.orderId });
    },

    hasTransactionItems: function () {
      return this.model.transactionItems instanceof Array && this.model.transactionItems.length > 0;
    },

    hasName: function () {
      return (
        this.model.transaction &&
        this.model.transaction.contactFirstName &&
        this.model.transaction.contactFirstName.length > 0
      );
    },

    process: function (transactions: any[]) {
      let i, ii, j, jj;
      let result: any[] | boolean = false;
      let transaction: any = {};
      const transactionItems: any[] = [];

      for (i = 0, ii = transactions.length; i < ii; i++) {
        if (transactions[i].transaction.id == $state.params.id) {
          transactions[i].transaction.orderBalance = $filter('currency')(transactions[i].transaction.orderBalance || 0);
          transactions[i].transaction.orderAmount = $filter('currency')(transactions[i].transaction.orderAmount || 0);
          transactions[i].transaction.discountedOrderAmount = $filter('currency')(
            transactions[i].transaction.discountedOrderAmount || 0
          );
          transactions[i].transaction.transactionAmount = $filter('currency')(
            transactions[i].transaction.transactionAmount || 0
          );
          transactions[i].transaction.netTransactionAmount = $filter('currency')(
            transactions[i].transaction.netTransactionAmount || 0
          );
          transactions[i].transaction.discountedTransactionAmount = $filter('currency')(
            transactions[i].transaction.discountedTransactionAmount || 0
          );
          transactions[i].transaction.resellerServiceFee = $filter('currency')(
            transactions[i].transaction.resellerServiceFee || 0
          );
          transactions[i].transaction.resellerServiceFeePercentage += '%';
          transactions[i].transaction.serviceFee = $filter('currency')(transactions[i].transaction.serviceFee || 0);
          transactions[i].transaction.serviceFeePercentage += '%';
          transactions[i].transaction.fixedFee = $filter('currency')(transactions[i].transaction.fixedFee || 0);
          transactions[i].transaction.percentFee = $filter('currency')(transactions[i].transaction.percentFee || 0);
          transactions[i].transaction.transactionDisplayDate =
            $filter('date')(CalendarService.parseDate(transactions[i].transaction.transactionDate), this.dateFormat) +
            ' at ' +
            $filter('date')(CalendarService.parseDate(transactions[i].transaction.transactionDate), this.hourFormat);
          transactions[i].transaction.paymentDueDisplayDate =
            $filter('date')(CalendarService.parseDate(transactions[i].transaction.paymentDueDate), this.dateFormat) +
            ' at ' +
            $filter('date')(CalendarService.parseDate(transactions[i].transaction.transactionDate), this.hourFormat);
          transactions[i].transaction.parentTransactionDisplayDate = $filter('date')(
            CalendarService.parseDate(transactions[i].transaction.parentTransactionDate),
            this.parentDateFormat
          );

          transaction = transactions[i];

          for (j = 0, jj = transactions[i].transactionItems.length; j < jj; j++) {
            transactions[i].transactionItems[j].amount = $filter('currency')(
              transactions[i].transactionItems[j].amount || 0
            );
            transactions[i].transactionItems[j].discountedOrderAmount = $filter('currency')(
              transactions[i].transactionItems[j].discountedOrderAmount || 0
            );
            transactions[i].transactionItems[j].netTransactionAmount = $filter('currency')(
              transactions[i].transactionItems[j].netTransactionAmount || 0
            );
            transactions[i].transactionItems[j].discountedTransactionAmount = $filter('currency')(
              transactions[i].transactionItems[j].discountedTransactionAmount || 0
            );
            transactions[i].transactionItems[j].displayEventStartTime = $filter('date')(
              CalendarService.parseDate(transactions[i].transactionItems[j].eventStartTime),
              this.dateTimeFormat
            );
            transactions[i].transactionItems[j].netAmount = $filter('currency')(
              transactions[i].transactionItems[j].netAmount || 0
            );
            transactions[i].transactionItems[j].paymentAmount = $filter('currency')(
              transactions[i].transactionItems[j].paymentAmount || 0
            );
            transactions[i].transactionItems[j].resellerServiceFee = $filter('currency')(
              transactions[i].transactionItems[j].resellerServiceFee || 0
            );
            transactions[i].transactionItems[j].resellerServiceFeePercentage += '%';
            transactions[i].transactionItems[j].serviceFee = $filter('currency')(
              transactions[i].transactionItems[j].serviceFee || 0
            );
            transactions[i].transactionItems[j].serviceFeePercentage += '%';
            transactions[i].transactionItems[j].unitPrice = $filter('currency')(
              transactions[i].transactionItems[j].unitPrice || 0
            );
            transactionItems.push(transactions[i].transactionItems[j]);
          }
        }
      }

      transaction.transactionItems = transactionItems;
      result = angular.copy(transaction);

      return result;
    },

    success: {
      init: function (response) {
        const self = $scope.ordersTransactionsDetail;

        self.model = self.process(angular.copy(response.data.payload));
        self.isLoaded = true;

        if (!$scope.$$phase) {
          $scope.$apply();
        }

        self.gridDefinition.isLoaded = true;
        $timeout(function () {
          $scope.$broadcast('DataGrid::ResizeGrid', {
            name: self.gridDefinition.options.gridName,
            datasetLength: self.model.transactionItems.length,
            totalItems: self.model.transactionItems.length,
          });
        }, 10);
      },
    },

    error: {
      init: function (response) {},
    },
  };

  $scope.ordersTransactionsDetail.init();
}

export const OrderDetailsTransactionsDetailControllerModule = angular
  .module('acme.view.application.orders.detail.transactions.detail.controllers', [
    uiRouter,
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
    'acme.common.service.userPreferences',
  ])

  .controller('OrdersTransactionsDetailController', OrdersTransactionsDetailController).name;
